import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface EmployeeFilterData {
  id: string
  fullName: string
  access: {
    id: string
    avatar?: string | null
  }
}

const employeeFilter = (
  source: ReturnType<typeof useDocumentsDataTable>,
  employees: EmployeeFilterData[]
) => {
  const options = employees
    .map((employee) => ({
      label: employee.fullName,
      value: employee.id,
      component: (
        <Box gap="s8" flexDirection="row" alignItems="center">
          <Avatar
            label={employee.fullName}
            url={employee.access.avatar ? buildUrl(employee.access.avatar) : undefined}
            size="s32"
          />
          <Text.Normal>{employee.fullName}</Text.Normal>
        </Box>
      ),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'employee_id',
    path: 'employee',
    title: i18n.t('documents.employee.filters.employee'),
  })
}

export default employeeFilter
